var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 30,
    viewBox: "0 0 44 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H41C42.6569 0 44 1.34315 44 3V27C44 28.6569 42.6569 30 41 30H3C1.34315 30 0 28.6569 0 27V3Z",
    fill: "#0742A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0149 19.3982H17.6552L19.1311 10.7034H21.4908L20.0149 19.3982Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5693 10.9158C28.1039 10.7399 27.3656 10.5457 26.4528 10.5457C24.1224 10.5457 22.4814 11.7296 22.4713 13.4222C22.452 14.6711 23.6463 15.3647 24.5395 15.7811C25.4525 16.2066 25.7628 16.4843 25.7628 16.8636C25.7535 17.4461 25.0251 17.7146 24.3457 17.7146C23.4035 17.7146 22.8987 17.5761 22.1316 17.2521L21.8208 17.1131L21.4906 19.065C22.0441 19.3052 23.0638 19.5184 24.1224 19.5277C26.5985 19.5277 28.2105 18.3621 28.2296 16.5583C28.239 15.5685 27.6084 14.8101 26.2488 14.1904C25.4234 13.7925 24.918 13.5243 24.918 13.1172C24.9276 12.7472 25.3455 12.3681 26.2772 12.3681C27.0443 12.3496 27.608 12.5252 28.035 12.7011L28.2484 12.7934L28.5693 10.9158Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7934 10.7034H34.6187L36.5224 19.3981H34.3375C34.3375 19.3981 34.1237 18.3991 34.0559 18.0938H31.0261C30.9385 18.325 30.5309 19.3981 30.5309 19.3981H28.0548L31.56 11.4248C31.8028 10.8605 32.2305 10.7034 32.7934 10.7034ZM32.6478 13.8851C32.6478 13.8851 31.9 15.8184 31.7057 16.3179H33.6671C33.5701 15.8832 33.1232 13.8019 33.1232 13.8019L32.9583 13.0527C32.8889 13.2456 32.7884 13.5109 32.7207 13.6898C32.6748 13.811 32.6439 13.8926 32.6478 13.8851Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6842 10.7034L13.3731 16.6324L13.1206 15.4299C12.6933 14.0424 11.3534 12.5349 9.85803 11.7854L11.9748 19.389H14.4703L18.1795 10.7034H15.6842V10.7034Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2271 10.7034H7.43044L7.3916 10.8791C10.3533 11.6006 12.3147 13.3398 13.1206 15.4303L12.2952 11.4343C12.1593 10.8789 11.7417 10.7217 11.2271 10.7034Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaSm);
export default __webpack_public_path__ + "static/media/Visa_sm.730f54b694e6a2536f2a786b77bf414f.svg";
export { ForwardRef as ReactComponent };